import { render } from "./EventGroup.vue?vue&type=template&id=edaa080a&ts=true"
import script from "./EventGroup.vue?vue&type=script&lang=ts"
export * from "./EventGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__